export default __webpack_public_path__ + "static/media/tmobilitat.06ec8460.jpeg";